import React from 'react';
import styles from './RouteStep.module.scss';
import Pic from './Pic';
import Icon from './Icon';

export default function RouteStep({ step, isFirst }) {
	const stepText = step.instructions.replace(new RegExp('[^<]/', 'g'), ' / ');

	const maneuver = step.maneuver;
	let icon = 'geolocator_black';
	let rotateDegree;

	if (!isFirst) {
		icon = 'right_arrow_black';
		if (maneuver.includes('straight')) {
			rotateDegree = -90;
		} else if (maneuver.includes('right')) {
			rotateDegree = 0;
		} else if (maneuver.includes('left')) {
			rotateDegree = 180;
		} else {
			rotateDegree = -90;
		}
	}

	return (
		<div className={styles.root}>
			<Pic
				icon={
					<Icon
						size="x-large"
						icon={`icon/${icon}.png`}
						rotateDegree={rotateDegree}
					/>
				}
				distance={step.distance.text}
			/>
			<p
				className={styles.stepText}
				dangerouslySetInnerHTML={{ __html: stepText }}
			></p>
		</div>
	);
}
